import { render, staticRenderFns } from "./TooltipInformacaoAlterada.vue?vue&type=template&id=e9bc94de&scoped=true&"
import script from "./TooltipInformacaoAlterada.vue?vue&type=script&lang=js&"
export * from "./TooltipInformacaoAlterada.vue?vue&type=script&lang=js&"
import style0 from "./TooltipInformacaoAlterada.vue?vue&type=style&index=0&id=e9bc94de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bc94de",
  null
  
)

export default component.exports